"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortInfoSchema = exports.SortInfoItem = void 0;
var zod_1 = require("zod");
exports.SortInfoItem = zod_1.z.object({
    /** 정렬 코드값 */
    key: zod_1.z.string(),
    /** 노출명 */
    title: zod_1.z.string(),
    /** 현재 선택된 정렬 값 */
    selected: zod_1.z.boolean(),
    /** 전달된 정렬 정보 중 기본값에 해당하는 정렬인지 여부 */
    isDefault: zod_1.z.boolean().nullish(),
    /** 정렬 설명 */
    description: zod_1.z.string().nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.SortInfoSchema = zod_1.z.object({
    items: zod_1.z.array(exports.SortInfoItem),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
